import { useRef, useEffect, useState } from 'react';
import { apiWithInterceptor } from '../../../../api';
import { useDrop } from 'react-dnd';
import DragDropArea from './dragDropArea/dragDropArea';
// UI Elements
import {
  Card,
  Text,
  Grid,
  List,
  Box,
  Accordion,
  UnstyledButton,
  useMantineTheme,
  ActionIcon,
  CloseButton,
  TextInput,
  Button,
} from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { IconPlus, IconMenu2 } from '@tabler/icons';
import { useMediaQuery } from '@mantine/hooks';
// jquery Sortable component

import $ from 'jquery';
import 'jquery-ui-dist/jquery-ui';

// utils
import PageHeading from '../../../../components/PageHeading';
import FormField from './FormField';
import AddFieldModal from './Modals/AddField';
import { useSetState } from '@mantine/hooks';

export default function FormBuilder() {
  const theme = useMantineTheme();
  const fieldsListRef = useRef();
  const sortableInit = useRef(false);
  const [addFieldModalState, setAddFieldModalState] = useState(false);
  const ITEM_TYPE = [
    'Text',
    'number',
    'select',
    'checkbox',
    'radio',
    'location',
    'location',
    'file',
  ];
  const [{ canDrop, isOver }, drop] = useDrop(() => ({
    accept: ITEM_TYPE,

    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  }));
  const matches = useMediaQuery('(min-width: 56.25em)');
  const [isPhoneScreen, setIsPhoneScreen] = useState(false);
  const isActive = canDrop && isOver;
  let borderColor = 'none';
  let backgroundColor = 'none';
  if (isActive) {
    borderColor = '#fbbe32';
    backgroundColor = '#fbbe3222';
  } else if (canDrop) {
    borderColor = '#fbbe32';
    backgroundColor = '#fbbe3222';
  }

  useEffect(() => {
    if (matches) {
      setIsPhoneScreen(false);
    } else {
      setIsPhoneScreen(true);
    }
  }, [matches]);
  // Setting the field object values
  const [fieldsObj, setFieldsObj] = useSetState({
    fields: {},
    ids: [],
  });

  const [formName, setFormName] = useState('');

  // const getFields = () => {
  //   return Object.keys(fieldsObj.fields).map((key) => {
  //     return fieldsObj.fields[key];
  //   });
  // };

  // Render the last fields order after implementing Jquery on the DOM
  const getFieldsOrdered = () => {
    let fields = [];
    fieldsObj.ids.forEach((id) => {
      fields.push(fieldsObj.fields[id]);
    });
    return fields;
  };

  // Set the values that comes form the Field Form component
  const setFieldValues = (id, values) => {
    setFieldsObj({
      fields: {
        ...fieldsObj.fields,
        [id]: {
          ...fieldsObj.fields[id],
          values,
        },
      },
    });
  };

  const addField = (field) => {
    setFieldsObj((prevFieldsObj) => {
      const id = `field_${prevFieldsObj.ids.length}`;
      const newField = {
        ...field,
        id,
      };
      return {
        fields: {
          ...prevFieldsObj.fields,
          [id]: newField,
        },
        ids: [...prevFieldsObj.ids, id],
      };
    });
  };

  const removeField = (id) => {
    delete fieldsObj.fields[id];
    setFieldsObj({
      ids: fieldsObj.ids.filter((fieldId) => fieldId !== id),
    });
  };

  // Set the new order to render in the fields component

  const setFieldsOrder = (newOrder) => {
    setFieldsObj({
      ids: newOrder,
    });
  };

  // Sort the new order for the fields

  useEffect(() => {
    if (sortableInit.current) {
      $(fieldsListRef.current).sortable('refresh');
    } else {
      $(fieldsListRef.current).sortable({
        items: '>li',
        stop: (event, ui) => {
          const newOrder = $(fieldsListRef.current).sortable('toArray', {
            attribute: 'id',
          });
          setFieldsOrder(newOrder);
        },
      });
      sortableInit.current = true;
    }
  }, [fieldsObj.ids.length]);

  const user = JSON.parse(localStorage.getItem('userInfo'));

  const fields = getFieldsOrdered().map((item) => {
    if (!item.values) return item;
    const values = item.values;
    values.default_value = '';
    values.default_value = item.values.defaultValue;
    delete values.defaultValue;
    return {
      data_type: item.dataType.toUpperCase(),
      presentation: item.presentation.toUpperCase(),
      ...values,
    };
  });
  const handelSubmit = (e) => {
    e.preventDefault();
    apiWithInterceptor
      .post('/form', {
        fields: fields,
        name: formName,
        user_id: user.id,
      })
      .then(function (response) {
        showNotification({
          title: `${response?.request?.statusText}`,
          message: 'Form Successfully created',
          color: 'green',
        });
        setFieldsObj({
          fields: {},
          ids: [],
        });
        setFormName('');
      })
      .catch(function (error) {
        console.log(error);
        showNotification({
          title: 'Failed to create a new form',
          message: ` ${error?.response?.data?.message}`,
          color: 'red',
        });
      });
  };

  return (
    <div
      style={{
        position: 'relative',
      }}
    >
      <form
        onSubmit={(e) => {
          handelSubmit(e);
        }}
        style={{
          width: isPhoneScreen ? '100%' : '75%',
        }}
      >
        <PageHeading>New Form</PageHeading>
        <Grid mb={'xs'}>
          <Grid.Col span={12}>
            <TextInput
              onChange={(e) => setFormName(e.target.value)}
              placeholder='Form Name'
            />
          </Grid.Col>
        </Grid>
        <Text size={'sm'} mb={'xs'}>
          Fields
        </Text>
        <Card
          p={0}
          sx={{
            background: 'transparent',
            overflow: 'visible',
          }}
          ref={drop}
          data-id='dropzone'
        >
          <List
            id='fields-list'
            ref={fieldsListRef}
            mb={'sm'}
            sx={{
              listStyle: 'none',
              border: '2px dashed #ced4da',
              borderColor: borderColor,
              backgroundColor: backgroundColor,
              padding: '20px',
              borderRadius: '10px',
              height: 'auto',
              display: fieldsObj.ids.length === 0 ? 'flex' : null,
              justifyContent: fieldsObj.ids.length === 0 ? 'center' : null,
              minHeight: '500px',
              '&>*:not(last-child)': {
                marginBottom: '20px',
              },
            }}
          >
            {fieldsObj.ids.length === 0 && (
              <List.Item
                sx={{
                  display: isPhoneScreen ? 'none' : 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {isActive ? (
                  <h2>Release to drop</h2>
                ) : (
                  <h2>Drag fields here</h2>
                )}
              </List.Item>
            )}

            {Object.keys(fieldsObj.fields)
              .map((id) => fieldsObj.fields[id])
              .reverse()
              .map((field) => (
                <List.Item
                  id={field.id}
                  key={field.id}
                  sx={{ '& > *': { width: '100%' } }}
                >
                  <Card withBorder p={0} sx={{ overflow: 'visible' }}>
                    <Accordion
                      chevronPosition='right'
                      m={0}
                      pl={'sm'}
                      pr={'md'}
                    >
                      <Accordion.Item value={field.label} sx={{ border: 0 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <Box
                            sx={{
                              cursor: 'move',
                            }}
                          >
                            <IconMenu2 size={16} />
                          </Box>
                          <Accordion.Control py={15}>
                            <Text>{field.label}</Text>
                            <Text size='sm' color='dimmed' weight={400}>
                              {field.type}
                            </Text>
                          </Accordion.Control>
                          <ActionIcon size='lg'>
                            <CloseButton
                              size='md'
                              onClick={() => removeField(field.id)}
                            />
                          </ActionIcon>
                        </Box>
                        <Accordion.Panel>
                          <FormField
                            field={field}
                            setFieldValues={setFieldValues}
                          />
                        </Accordion.Panel>
                      </Accordion.Item>
                    </Accordion>
                  </Card>
                </List.Item>
              ))}
          </List>
          <UnstyledButton
            sx={{ width: '100%' }}
            onClick={() => {
              setAddFieldModalState(true);
            }}
          >
            <Card
              withBorder
              py={30}
              sx={{
                display: isPhoneScreen ? '' : 'none',
                transition: '.3s',
                '&:hover': {
                  borderColor: theme.colors.brand[4],
                  backgroundColor: `${theme.colors.brand[9]}02`,
                },
                '&:hover *': {
                  color: theme.colors.brand[5],
                },
              }}
            >
              <Grid
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                }}
              >
                <IconPlus />

                <Text ml={'xs'}>Add Field</Text>
              </Grid>
            </Card>
          </UnstyledButton>
        </Card>

        <Button mt={'lg'} type='submit'>
          Create Form
        </Button>
        <AddFieldModal
          opened={addFieldModalState}
          onClose={() => {
            setAddFieldModalState(false);
          }}
          onFieldClick={(field) => {
            addField(field);
            setAddFieldModalState(false);
          }}
        />
      </form>

      <Card
        sx={{
          position: 'absolute',
          top: '-30px',
          right: '-20px',
          height: '100vh',
          width: '300px',
          borderLeft: '1px solid #e9ecef',
          display: isPhoneScreen ? 'none' : 'flex',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <h2>Fields Selector</h2>
        <div>
          <DragDropArea onFieldDrop={addField} />
        </div>
      </Card>
    </div>
  );
}
